const MEALS_URL = 'https://www.themealdb.com/api/json/v1';
const MAX_RECIPES = 12;

const getToken = (key) => {
  const token = localStorage.getItem(key);
  const parsedToken = token ? JSON.parse(token) : '1';

  return parsedToken;
};

const getTypeInfo = (type) => {
  if (type === 'meals') {
    return [getToken('mealsToken'), MEALS_URL];
  }
  return [getToken('cocktailsToken'), DRINKS_URL];
};

export const getMealAreas = async () => {
  const [typeToken, typeUrl] = getTypeInfo('meals');
  const response = await fetch(`${typeUrl}/${typeToken}/list.php?a=list`);
  const data = await response.json();

  return data.meals;
};

export const getMealsByArea = async (area) => {
  const [typeToken, typeUrl] = getTypeInfo('meals');
  const response = await fetch(`${typeUrl}/${typeToken}/filter.php?a=${area}`);
  const data = await response.json();

  return data.meals.slice(0, MAX_RECIPES);
};
